<template>
  <Header :style="headerStyle">
    <slot></slot>
  </Header>
</template>

<script>
export default {
  name: "SiLayoutHeader",
  props: {
    headerStyle: {
      type: Object,
      default() {
        return {
          backgroundColor: "rgb(210,139,82)",
          height: "50px",
          padding: "0px",
          lineHeight: "unset",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "rgb(210,139,82)",
          borderLeft: "none",
          borderRight: "none",
          color:"rgb(255,255,255)"
        };
      }
    }
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Layout/layout-header.vue